module.exports = __webpack_public_path__ + "static/media/programmer.b345aaef.jpg";